import { getDataSimple } from "../helpers/apiHelperV3";
//
const API_NOTIFICATIONS = "/data/v3/notificationDisplays/platform/";

/**
 * fetch report count
 */
export const fetchNotificationList = (platform: string): any => {
  const url = API_NOTIFICATIONS + platform;
  return getDataSimple(url);
};
